<template>
  <div>
    <a ref="hiddenLink" :href="url" target="_blank" style="display: none"></a>
  </div>
</template>

<script>
export default {
  // 计算属性
  computed: {
    // 当前路由
    currentRoute() {
      return this.$route
    },
    // 路由信息
    routeMeta() {
      return this.currentRoute?.meta || {}
    },
    // 应用地址
    url() {
      return this.currentRoute.meta.url || ''
    }
  },
  mounted() {
    this.openUrlInNewTab()
  },
  methods: {
    openUrlInNewTab() {
      setTimeout(() => {
        if (this.url) {
          // 创建一个隐藏的 <a> 标签并触发点击事件
          const link = this.$refs.hiddenLink
          link.click()
          this.$router.go(-1)
        }
      }, 500)
    }
  }
}
</script>
